import React from 'react';
import PropTypes from 'prop-types';
import config from '../config';

class TemporaryNode extends React.Component {
  componentDidMount() {
    this.nameInput.focus();
  }

  render() {
    const { x, y } = this.props;
    const transform = `translate( ${x}, ${y})`;
    return (
      <g transform={transform} width={config.sizes.nodeWidth} height={config.sizes.temporaryNodeHeight}>
        <path
          d="M 0 0 L 0 0"
          stroke="#2A60E4"
          strokeWidth="1"
          fill="none"
        />
        <foreignObject width={config.sizes.nodeWidth} height={config.sizes.temporaryNodeHeight}>
          <div xmlns="http://www.w3.org/1999/xhtml" className="temporary-node">
            <input
              className="temporary-node-name"
              placeholder=""
              type="text"
              ref={(input) => {
                this.nameInput = input;
              }}
              onInput={this.handleTemporaryNodeInput}
              onKeyPress={this.handleTemporaryNodeKeyPress}
            />
          </div>
        </foreignObject>
      </g>
    );
  }

  handleTemporaryNodeInput = (event) => {
    const { data } = this.props;
    data.name = event.target.value;
  };

  handleTemporaryNodeKeyPress = (event) => {
    const { cleanTemporaryNodes } = this.props;
    const code = (event.keyCode ? event.keyCode : event.which);
    if (code === 13) {
      event.preventDefault();
      cleanTemporaryNodes();
    }
  }
}

TemporaryNode.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  data: PropTypes.object.isRequired,
  cleanTemporaryNodes: PropTypes.func.isRequired,
};

export default TemporaryNode;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/components/TemporaryNode.jsx